import React from "react"
import { Grid, InputLabel, TextField } from "@material-ui/core"

type SnoozeNoteFieldProps = {
	value: string | null
	onChange: (note: string) => void
}

const SnoozeNoteField: React.FC<SnoozeNoteFieldProps> = ({
	value,
	onChange
}) => {
	return (
		<Grid item xs={12}>
			<Grid container spacing={1}>
				<Grid item xs={12}>
					<InputLabel>Deseja inserir uma observação?</InputLabel>
				</Grid>
				<Grid item xs={12}>
					<TextField
						value={value || ""}
						onChange={({ target }) => onChange(target.value)}
						variant="outlined"
						placeholder="Será mostrada apenas para você ao despertar do soneca (opcional)"
						color="primary"
						multiline
						fullWidth
						minRows={2}
					/>
				</Grid>
			</Grid>
		</Grid>
	)
}

export default SnoozeNoteField
